import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState, USER_FEATURE_KEY } from './user.reducer';
import { UserDetails } from '@classifieds-sell/datalayer';

export const getUserState = createFeatureSelector< UserState>(
    USER_FEATURE_KEY
);

export const getUserDetails = createSelector(
    getUserState,
    (state: UserState) => {
        return {
            memberSummary: state.memberSummary,
            topUpAccountStatus: state.topUpAccountStatus,
            features: state.features
        } as UserDetails;
    }
);

export const getMemberSummary = createSelector(
    getUserState,
    (state: UserState) => state.memberSummary
);

export const getTopUpAccountStatus = createSelector(
    getUserState,
    (state: UserState) => state.topUpAccountStatus
);

export const updateUserDetailsResponse = createSelector(
    getUserState,
    (state: UserState) => state.updateUserDetailsResponse
);